<template>
  <div id="appl-search" class="dashboard-box">
    <div class="title">
      <h1>
        {{ $route.meta.title }}
        <span
          class="title__logout">
          <a
            v-if="loggedInUser.roles[0].type === 'ROLE_ONLY_APPL_DOC'"
            @click="_logout()"
            class="btn gradient-btn small">
            로그아웃
          </a>
          <a v-else
             @click="_close()"
             class="btn gradient-btn small">
             닫기
          </a>
        </span>
      </h1>
    </div>
    <div class="content">
      <div class="row">
        <div class="col col-4">
          <input-select label="전형" :options="partList.adms" v-model="applSearch.adms" @input="_admsInput"
                        :reduce="value=> value" :clearable="partList.adms.length > 0"></input-select>
        </div>
        <div class="col col-4">
          <input-select label="캠퍼스" :options="partList.campus" v-model="applSearch.campus" @input="_campusInput"
                        :reduce="value=> value" :clearable="partList.campus.length > 0"
          ></input-select>
        </div>
        <div class="col col-5">
          <input-select label="대학" :options="partList.college" v-model="applSearch.college" @input="_collegeInput"
                        :reduce="value=> value" :clearable="partList.college.length > 0"></input-select>
        </div>
      </div>
      <div class="row">

        <div class="col col-5">
          <input-select label="학과" :options="partList.dept" v-model="applSearch.dept" @input="_deptInput"
                        :reduce="value=> value" :clearable="partList.dept.length > 0"></input-select>
        </div>
        <div class="col col-8">
          <input-select label="세부지원분야" :options="partList.detail" v-model="applSearch.detlDeptCode" @input="_deptDeptInput"
                        :reduce="value=> value" :clearable="partList.detail.length > 0"></input-select>
        </div>
      </div>
      <slot ></slot>
      <div class="row">
        <div class="col col-9"></div>
        <!-- TODO: 추후 엑셀 다운로드 로직 개선 시 복구 22.10.06 안상철 -->
<!--        <div class="col col-2">-->
<!--          <button-->
<!--            v-if="canDownloadExcel && this._search.dept != null && this._search.adms != null"-->
<!--            class="btn gradient-btn-2"-->
<!--            @click.prevent="excelDownload">학과_전형별 지원자 정보 다운로드</button>-->
<!--        </div>-->
        <div class="col col-2">
          <button
            class="btn gradient-btn-2"
            @click.prevent="_clearSearchParam">검색조건 초기화</button>
        </div>
        <div class="col col-2">
          <button class="btn gradient-btn" @click.prevent="search">검색</button>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import ajax from '@/wrapper/ajax'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import typeUtil from '@/utils/type'
import Constants from '@/Constants'
export default {
  name: 'appl-search',
  data () {
    return {
      canDownloadExcel: false,
      userId: '',
      evalGradRole: '',
      partList: {
        adms: [],
        campus: [],
        college: [],
        dept: [],
        detail: []
      },
      applSearch: {
        evalGradRole: '',
        campus: { code: null, value: '' },
        adms: { code: null, value: '' },
        college: { code: null, value: '' },
        dept: { code: null, value: '' },
        detlDeptCode: { code: null, value: '' }
      },
      semester: 0
    }
  },
  computed: {
    ...mapGetters({
      savedApplPartParam: 'appl/applPartParam',
      savedPartList: 'appl/partList',
      isBeforeDetail: 'appl/isBeforeDetail',
      loggedInUser: 'users/loggedInUser',
      getEvalPeriodInfo: 'eval/getEvalPeriodInfo'
    }
    ),
    _search () {
      return {
        evalGradRole: this.evalGradRole,
        adms: this.applSearch.adms.code,
        campus: this.applSearch.campus.code,
        college: this.applSearch.college.code,
        dept: this.applSearch.dept.code,
        detlDeptCode: this.applSearch.detlDeptCode.code
      }
    }
  },
  methods: {
    ...mapMutations({
      logout: 'users/LOGOUT',
      setApplPartParam: 'appl/SET_APPL_PART_PARAM',
      setBeforeDetail: 'appl/SET_BEFORE_DETAILL'
    }),
    ...mapActions({
      _getEvalPeriodInfo: 'eval/getEvalPeriodInfo'
    }),
    _logout () {
      this.logout()
    },
    _close () {
      window.close()
    },
    isDept (role) {
      return Constants.EVAL_GRAD_ROLE_TYPE.GRAD_DEPT === role
    },
    search () {
      this.setApplPartParam(this.applSearch)
      this.$emit('search', this._search)
    },
    excelDownload () {
      this.$emit('excelDownload')
    },
    _admsInput () {
      this.applSearch.adms = this._clear(this.applSearch.adms)
      this._getCampList()
    },
    _campusInput (val) {
      this.applSearch.campus = this._clear(this.applSearch.campus)
      this.applSearch = {
        ...this.applSearch,
        college: { code: null, value: '' },
        dept: { code: null, value: '' },
        detlDeptCode: { code: null, value: '' }
      }
      this.partList.college = []
      this.partList.dept = []
      this.partList.detail = []

      if (val) {
        this._getCollList()
      }
    },
    _collegeInput (val) {
      this.applSearch.college = this._clear(this.applSearch.college)
      this.applSearch = {
        ...this.applSearch,
        dept: { code: null, value: '' },
        detlDeptCode: { code: null, value: '' }
      }
      this.partList.dept = []
      this.partList.detail = []

      if (val) {
        this._getDeptList()
      }
    },
    _deptInput (val) {
      this.applSearch.dept = this._clear(this.applSearch.dept)
      this.applSearch.detlDeptCode = { code: null, value: '' }
      this.partList.detail = []

      if (val) {
        this._getDetailDeptList()
      }
    },
    _deptDeptInput () {
      this.applSearch.detlDeptCode = this._clear(this.applSearch.detlDeptCode)
    },
    _clear (val) {
      this.canDownloadExcel = false
      return typeUtil.isNull(val) ? { code: null, value: '' } : val
    },
    // 모집단위 초기화
    async _clearSearchParam () {
      await this._campusInput()
      this.applSearch = {
        evalGradRole: this.evalGradRole,
        campus: { code: null, value: '' },
        adms: { code: null, value: '' },
        college: { code: null, value: '' },
        dept: { code: null, value: '' },
        detlDeptCode: { code: null, value: '' }
      }
      await this.$emit('clear')
      await this._getAdmsList()
    },
    _initPartList () {
      this._getAdmsList()
      // 상세화면 방문여부 false
      if (!this.isBeforeDetail) {
        this._clearSearchParam()
        // 상세화면 방문여부 true
      } else {
        this.setBeforeDetail(false)
        this.applSearch = this.savedApplPartParam
        this.search()
        this.checkEvalGradRole(this.loggedInUser.userId).then(res => {
          if (this.applSearch.dept.code != null) this._getDetailDeptList()
          if (this.applSearch.college.code != null) this._getDeptList()
          if (this.applSearch.campus.code != null) this._getCollList()
          if (this.applSearch.adms.code != null) this._getCampList()
        })
      }
    },
    // 전형
    _getAdmsList () {
      ajax('GET', '/api/school-infos/adms-type-list', null, null, {
        semester: this.semester
      }).then(_res => {
        this.partList.adms = _res
        this.applSearch.adms = this.partList.adms[0]
        this._getCampList()
      })
    },
    // 캠퍼스
    _getCampList () {
      this.getEvalGradCampuses(this.loggedInUser.userId, this.applSearch.adms.code, this.evalGradRole).then(res => {
        this.partList.campus = res
        if (this.isDept(this.evalGradRole)) {
          this.applSearch.campus = this.partList.campus[0]
          this._getCollList()
        }
      })
    },
    // 단과대학
    _getCollList () {
      this.getEvalGradColleges(this.loggedInUser.userId, this.applSearch.adms.code, this.evalGradRole, this._search.campus).then(res => {
        this.partList.college = res
        if (this.isDept(this.evalGradRole)) {
          this.applSearch.college = this.partList.college[0]
          this._getDeptList()
        }
      })
    },
    // 학과
    _getDeptList () {
      this.getEvalGradDepts(this.loggedInUser.userId, this.applSearch.adms.code, this.evalGradRole, this._search.college).then(res => {
        this.partList.dept = res
        if (this.isDept(this.evalGradRole)) {
          this.applSearch.dept = this.partList.dept[0]
          this._getDetailDeptList()
        }
      })
    },
    // 세부지원분야
    _getDetailDeptList () {
      this.getEvalGradDtml(this.applSearch.adms.code, this._search.dept).then(res => {
        this.partList.detail = res
      })
    }
  },
  async created () {
    await this._getEvalPeriodInfo()
    this.semester = this.getEvalPeriodInfo.semester
    await this.getEvalGradRoleName(this.loggedInUser.userId).then(res => {
      this.evalGradRole = res
    })
    await this._initPartList()
  }
}
</script>
